//@flow
import React from 'react';
import image from '../../../images/office/snack-from-home-square.jpg';
import Link from '../../../components/Link';

const config = {
  image: image,
  title: 'NatureBox Snack from Home',
  subtitle: 'With more companies shifting to remote working environments, it’s important to provide the same perks, like office snacks, to maintain employee happiness and a sense of connection and community within the company. That’s why we developed our Snack from Home program. Snack from Home will deliver snack boxes directly to your remote employees. Keep your remote employees happy and healthy with our Snack from Home options. Choose one of our curated Snack from Home boxes:',
  footer: 'We can also put together a custom box just for you and your team.',
  footerCta: 'Contact us to learn more.',
  checks: [
    {
      text: 'Less Stress Box',
    },
    {
      text: 'Snack from Home Sweetish Box',
    },
    {
      text: 'Snack from Home Delectable Box',
    },
    {
      text: 'Snack from Home Delightful Box',
    },
  ],
};

const {title, subtitle, checks, footer, footerCta} = config;

export default function WhyNatureboxSection() {
  const style = {
    backgroundImage: `url(${config.image})`,
  };
  return (
    <div className="snack-from-home">
      <div className="inner">
        <div className="left">
          <div className="left-image" style={style} />
        </div>
        <div className="right">
          <div className="top">
            <h2>
              {title}
            </h2>
            <div className="subtitle text-2">
              {subtitle}
            </div>
          </div>
          <div className="checkmarks-container">
            {renderCheckmarks()}
          </div>
          <div className="bottom text-2">
            <span>{footer}</span>&nbsp;<Link to="/office#office-form">{footerCta}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

const renderCheckmarks = () => {
  return (
    <ul className="checkmarks">
      {checks.map((check, index) => (
        <li className="text-3" key={index}>{check.text}</li>
      ))}
    </ul>
  );
};
